<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close"
    (click)="modal.close('ferme')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form autocomplete="off" [formGroup]="form" (ngSubmit)="onConfirme()">
  <div class="modal-body">
    <div class="col-md-12">
      <aw-wizard #wizard class="arc-wizard">
        <!-- STEP 1 DU FORMULAIRE -->
        <aw-wizard-step stepTitle="Bâtiment">
          <div class="row">
            <span class="badge badge-info my-2 f-14 width">
              Partie reservée au programme
            </span>
          </div>
          <div class="form-group row">
            <div class="col-md-3">
              <label for="promotion">
                {{ (promotion?.parent != null && edit)? 'Sous programme': 'Programme'}} <span class="asterix"></span>
              </label>
              <ng-select [readonly]="edit" formControlName="promotion" class="form-control custom-ng-select"
                [items]="promotions" bindLabel="libelle" bindValue="uuid" class="form-control" id="promotion"
                (change)="onChangePromotion($event)">
              </ng-select>
            </div>
            <div *ngIf="edit == false &&  f.promotion.value && sousPromotions.length>0" class="col-md-3">
              <label for="type">
                Sous Programme <span class="asterix"></span>
              </label>
              <ng-select [readonly]="edit" formControlName="sousPromotion" class="form-control custom-ng-select"
                [items]="sousPromotions" bindLabel="libelle" bindValue="uuid" class="form-control" id="promotion"
                (change)="onChangeSousPromotion($event)">
              </ng-select>
            </div>
            <div class="col-md-3">
              <label for="numero">Situé </label>
              <input type="text" [value]="promotion?.localisation" class="form-control font-weight-bold p-2"
                placeholder="Situé" readonly>
            </div>
            <div class="col-md-3">
              <label for="numero">Superficie (m²)</label>
              <input type="text" [value]="promotion?.superficie" class="form-control font-weight-bold p-2"
                placeholder="Superficie (m²)" readonly>
            </div>
            <div class="col-md-3">
              <label for="numero">Nombre de maison </label>
              <input type="text" [value]="promotion?.nbrMaison" class="form-control font-weight-bold p-2"
                placeholder="Nombre de maison" readonly>
            </div>
          </div>

          <!-- Informations sur le bâtiment -->
          <div class="row">
            <span class="badge badge-info my-2 f-14 width">
              Informations sur le bâtiment
            </span>
          </div>
          <div class="form-group row">
            <div *ngIf="!edit" class="col-md-3">
              <label for="type">Type <span class="asterix">*</span></label>
              <select formControlName="type" class="form-control" id="type" [ngClass]="{
                  'is-invalid': submit && f.type.errors,
                  'is-valid': submit && f.type.valid
                }">
                <option *ngFor="let item of typeRow" [value]="item.value">{{item.label}}</option>
              </select>
              <div class="invalid-feedback" *ngIf="submit && f.type.errors">
                <div *ngIf="f.type.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div *ngIf="edit == false && buildings && f.promotion.value && f.type.value === 'UPDATE'" class="col-md-3">
              <label for="uuid">Bâtiment <span class="asterix">*</span></label>
              <select formControlName="uuid" class="form-control" id="uuid" [ngClass]="{
                  'is-invalid': submit && f.uuid.errors,
                  'is-valid': submit && f.uuid.valid
                }">
                <option *ngFor="let item of buildings" [value]="item.uuid">{{item.libelle}}</option>
              </select>
              <div class="invalid-feedback" *ngIf="submit && f.uuid.errors">
                <div *ngIf="f.uuid.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="libelle">Libellé <span class="asterix">*</span></label>
              <input id="libelle" formControlName="libelle" class="form-control" [ngClass]="{
                'is-invalid': submit && f.libelle.errors,
                'is-valid': submit && f.libelle.valid}" type="text" placeholder="Libellé">
              <div class="invalid-feedback" *ngIf="submit && f.libelle.errors">
                <div *ngIf="f.libelle.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="niveau">Niveau <span class="asterix">*</span></label>
              <input id="niveau" (ngModelChange)="onChangeNiveaux()" formControlName="niveau" class="form-control"
                [ngClass]="{
                'is-invalid': submit && f.niveau.errors,
                'is-valid': submit && f.niveau.valid}" type="number" min="1" placeholder="Nombre de niveaux">
              <div class="invalid-feedback" *ngIf="submit && f.niveau.errors">
                <div *ngIf="f.niveau.errors.required">{{required.novide}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label for="superficie">Superficie totale <span class="asterix">*</span></label>
              <input id="superficie" formControlName="superficie" class="form-control" [ngClass]="{
                'is-invalid': submit && f.superficie.errors,
                'is-valid': submit && f.superficie.valid}" type="number" min="0" placeholder="Superficie totale">
              <div class="invalid-feedback" *ngIf="submit && f.superficie.errors">
                <div *ngIf="f.superficie.errors.required">{{required.novide}}</div>
              </div>
            </div>
          </div>

          <!-- Configuration des paramètres de numérotation 
          <div *ngIf="this.f.niveau.value > 0 && !edit" class="card mb-3">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-cog me-2"></i>Configuration de la numérotation des portes
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-3">
                  <label for="radicalCode">
                    Radical du code (optionnel)
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Préfixe qui sera ajouté devant chaque numéro de porte. Ex: APT, A, etc.'"></i>
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="radicalCode"
                    [ngModelOptions]="{standalone: true}" id="radicalCode" placeholder="Ex: APT, A..."
                    (blur)="validateRadicalCode(radicalCode) || (radicalCode = '')">
                  <small class="text-muted">Laissez vide pour une numérotation simple (001, 002, etc.)</small>
                </div>
                <div class="col-md-2">
                  <label for="startNumber">
                    Numéro de départ <span class="asterix">*</span>
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Numéro à partir duquel commencer le décompte'"></i>
                  </label>
                  <input type="number" min="1" class="form-control" [(ngModel)]="startNumber"
                    [ngModelOptions]="{standalone: true}" id="startNumber" placeholder="Ex: 1, 100...">
                </div>
                <div class="col-md-3">
                  <label for="numberingMode">
                    Mode de numérotation
                    <i class="fas fa-info-circle" placement="right"
                      [ngbPopover]="'Choisissez comment numéroter les nouveaux appartements'"></i>
                  </label>
                  <select class="form-control" [(ngModel)]="numberingMode" [ngModelOptions]="{standalone: true}">
                    <option value="continue">Continuer la série existante</option>
                    <option value="restart">Redémarrer avec le n° de départ</option>
                  </select>
                </div>
                <div class="col-md-2">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-info form-control" (click)="regenerateAllPorteNumbers()"
                    *ngIf="appartementsGenerated.length > 0">
                    <i class="fas fa-sync-alt"></i> Appliquer
                  </button>
                </div>
                <div class="col-md-2">
                  <label>&nbsp;</label>
                  <button type="button" class="btn btn-success form-control" (click)="generateAllAppartements()"
                    *ngIf="canGenerateAppartements() && appartementsGenerated.length === 0">
                    <i class="fas fa-magic"></i> Générer
                  </button>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="alert alert-light">
                    <strong><i class="fas fa-eye me-2"></i>Aperçu du format :</strong>
                    <code>{{getPreviewPorteFormat()}}</code>
                    <br>
                    <small class="text-muted">
                      <strong>Mode :</strong>
                      <span *ngIf="numberingMode === 'continue'">
                        <i class="fas fa-arrow-right text-info"></i> Continuer après les appartements existants
                      </span>
                      <span *ngIf="numberingMode === 'restart'">
                        <i class="fas fa-redo text-warning"></i> Redémarrer depuis {{startNumber}}
                      </span>
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </div>-->

          <!-- Configuration niveau par niveau -->
          <div *ngIf="this.f.niveau.value > 0 && !edit && niveauxConfig.length > 0">
            <div class="row">
              <span class="badge badge-success my-2 f-14 width">
                CONFIGURATION PAR NIVEAU
              </span>
            </div>

            <!-- Affichage accordéon par niveau -->
            <div class="accordion" *ngFor="let niveau of niveauxConfig; let nIndex = index" 
                 [id]="'accordionNiveau' + nIndex">
              
              <div class="card mb-3">
                <div class="card-header" [id]="'headingNiveau' + nIndex">
                  <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" 
                            (click)="toggleNiveauExpansion(nIndex)"
                            [attr.aria-expanded]="niveau.expanded"
                            [attr.aria-controls]="'collapseNiveau' + nIndex">
                      <i class="fas fa-layer-group me-2"></i>
                      <strong>{{getNiveauLibelle(nIndex + 1)}}</strong>
                      <span class="badge badge-info ms-2" *ngIf="niveau.typesMaisons.length > 0">
                        {{getTotalMaisonsNiveau(niveau)}} appartements
                      </span>
                      <i class="fas float-right" 
                         [ngClass]="niveau.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </button>
                  </h2>
                </div>

                <div *ngIf="niveau.expanded" class="card-body">
                  <!-- Formulaire pour ajouter un type de maison à ce niveau -->
                  <div class="row mb-3 p-3 bg-light">
                    <div class="col-md-3">
                      <label>Type d'appartement <span class="asterix">*</span></label>
                      <ng-select [(ngModel)]="niveau.newType" 
                                 [ngModelOptions]="{standalone: true}"
                                 class="form-control custom-ng-select" 
                                 [items]="homeTypes"
                                 bindLabel="libelle" 
                                 bindValue="uuid"
                                 placeholder="Sélectionnez un type">
                      </ng-select>
                    </div>
                    <div class="col-md-1">
                      <label>Nombre <span class="asterix">*</span></label>
                      <input type="number" 
                             [(ngModel)]="niveau.newNombre" 
                             [ngModelOptions]="{standalone: true}"
                             class="form-control" 
                             min="1" 
                             placeholder="Ex: 3">
                    </div>
                    <div class="col-md-2">
                      <label>Superficie (m²) <span class="asterix">*</span></label>
                      <input type="number" 
                             [(ngModel)]="niveau.newSuperficie" 
                             [ngModelOptions]="{standalone: true}"
                             class="form-control" 
                             min="0" 
                             step="0.5"
                             placeholder="Ex: 85">
                    </div>
                    <div class="col-md-2">
                      <label>Montant <span class="asterix">*</span></label>
                      <input type="number" 
                             [(ngModel)]="niveau.newMontant" 
                             [ngModelOptions]="{standalone: true}"
                             class="form-control" 
                             min="0" 
                             step="1000"
                             placeholder="Ex: 25000">
                    </div>
                    <div class="col-md-2">
                      <label>Base actualisation <span class="asterix">*</span></label>
                      <input type="number" 
                             [(ngModel)]="niveau.newBaseActualisation" 
                             [ngModelOptions]="{standalone: true}"
                             class="form-control" 
                             min="0" 
                             step="1000"
                             placeholder="Ex: 23000">
                    </div>
                    <div class="col-md-2">
                      <label>&nbsp;</label>
                      <button type="button" 
                              class="btn btn-success btn-block"
                              (click)="addTypeMaisonToNiveau(nIndex)">
                        <i class="fas fa-plus"></i> Ajouter
                      </button>
                    </div>
                  </div>

                  <!-- Liste des types configurés pour ce niveau -->
                  <div *ngIf="niveau.typesMaisons.length > 0">
                    <h6 class="text-muted mb-3">Types d'appartements configurés :</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead class="thead-light">
                          <tr>
                            <th>Type</th>
                            <th>Nombre</th>
                            <th>Superficie (m²)</th>
                            <th>Montant</th>
                            <th>Base actualisation</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let typeMaison of niveau.typesMaisons; let tIndex = index">
                            <td>
                              <span class="badge badge-primary">{{getTypeMaisonLabel(typeMaison.typeUuid)}}</span>
                            </td>
                            <td><strong>{{typeMaison.nombre}}</strong></td>
                            <td>{{typeMaison.superficie}} m²</td>
                            <td>{{typeMaison.montant}} XOF</td>
                            <td>{{typeMaison.baseActualisation}} XOF</td>
                            <td>
                              <button type="button" 
                                      class="btn btn-sm btn-outline-danger"
                                      (click)="removeTypeMaisonFromNiveau(nIndex, tIndex)">
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div *ngIf="niveau.typesMaisons.length === 0" class="alert alert-info">
                    <i class="fas fa-info-circle me-2"></i>
                    Aucun type d'appartement configuré pour ce niveau. Ajoutez au moins un type.
                  </div>
                </div>
              </div>
            </div>

            <!-- Bouton pour générer tous les appartements -->
            <div class="text-center mt-3" *ngIf="canGenerateAppartements() && appartementsGenerated.length === 0">
              <button type="button" 
                      class="btn btn-success btn-lg"
                      (click)="generateAllAppartements()">
                <i class="fas fa-magic"></i> 
                Générer tous les appartements ({{getTotalAppartements()}})
              </button>
            </div>

            <div class="text-center mt-3" *ngIf="appartementsGenerated.length > 0">
              <div class="alert alert-success">
                <i class="fas fa-check-circle me-2"></i>
                <strong>{{appartementsGenerated.length}} appartements générés avec succès</strong>
              </div>
            </div>
          </div>

          <div *ngIf="!edit" class="col-md-12 text-center mt-2">
            <button type="button" awNextStep class="btn btn-primary"
              *ngIf="f.promotion.value && canProceedToNextStep()">
              Suivant <i class="feather icon-arrow-right"></i>
            </button>
          </div>
        </aw-wizard-step>

        <!-- STEP 2 DU FORMULAIRE -->
        <aw-wizard-step *ngIf="!edit && appartementsGenerated.length > 0" stepTitle="Appartements générés">
          <div class="row">
            <span class="badge badge-info my-2 f-14 width">
              Liste des appartements générés
            </span>
          </div>

          <!-- Regroupement par niveau -->
          <div *ngFor="let niveau of niveauxConfig; let nIndex = index" class="card mb-3">
            <ng-container *ngIf="getAppartementsByNiveau(nIndex + 1).length > 0">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-layer-group me-2"></i>
                {{getNiveauLibelle(nIndex + 1)}}
                <span class="badge badge-success ms-2">
                  {{getAppartementsByNiveau(nIndex + 1).length}} appartements
                </span>
              </h6>
            </div>

            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-sm table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>N° Porte</th>
                      <th>Niveau</th>
                      <th>Type</th>
                      <th>Superficie (m²)</th>
                      <th>Montant</th>
                      <th>Base actualisation</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let appartement of getAppartementsByNiveau(nIndex + 1); let appIndex = index">
                      <td>
                        <input type="text" 
                               [(ngModel)]="appartement.porte"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="updateAppartementPorte(appartement, $event)"
                               class="form-control form-control-sm"
                               style="background-color: white;">
                      </td>
                      <td>
                        <span class="badge badge-secondary">{{appartement.etageLabel}}</span>
                      </td>
                      <td>
                        <span class="badge badge-info">{{getTypeMaisonLabel(appartement.type)}}</span>
                      </td>
                      <td>
                        <input type="number" 
                               [(ngModel)]="appartement.superficie"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="updateAppartementSuperficie(appartement, $event)"
                               class="form-control form-control-sm" 
                               step="0.5" 
                               min="0"
                               style="background-color: white;">
                      </td>
                      <td>
                        <input type="number" 
                               [(ngModel)]="appartement.montant"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="updateAppartementMontant(appartement, $event)"
                               class="form-control form-control-sm" 
                               step="1000" 
                               min="0"
                               style="background-color: white;">
                      </td>
                      <td>
                        <input type="number" 
                               [(ngModel)]="appartement.baseActualisation"
                               [ngModelOptions]="{standalone: true}"
                               (blur)="updateAppartementBaseActualisation(appartement, $event)"
                               class="form-control form-control-sm" 
                               step="1000" 
                               min="0"
                               style="background-color: white;">
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </ng-container>
          </div>

          <!-- Statistiques globales -->
          <div class="card bg-light">
            <div class="card-header">
              <h6 class="mb-0">
                <i class="fas fa-chart-bar me-2"></i>
                Résumé du bâtiment
              </h6>
            </div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-building text-primary me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Niveaux</small>
                      <div class="font-weight-bold h4">{{f.niveau.value}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-home text-info me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Total appartements</small>
                      <div class="font-weight-bold h4">{{appartementsGenerated.length}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="d-flex align-items-center justify-content-center">
                    <i class="fas fa-ruler-combined text-success me-2 fa-2x"></i>
                    <div>
                      <small class="text-muted">Superficie totale</small>
                      <div class="font-weight-bold h4">{{f.superficie.value}} m²</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
              <button type="button" awNextStep class="btn btn-primary ml-1">
                Suivant <i class="feather icon-arrow-right"></i>
              </button>
            </div>
          </div>
        </aw-wizard-step>

        <!-- STEP 3 DU FORMULAIRE - OFFRE -->
        <aw-wizard-step *ngIf="!edit" stepTitle="Offre">
          <div class="row">
            <span class="badge badge-primary my-2 f-14 width"> Informations supplémentaires</span>
          </div>

          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux pièces du bien</span>
            <form autocomplete="off" [formGroup]="pieceForm">
              <div class="form-group">
                <div class="row mb-2">
                  <div class="col-md-3">
                    <label for="chambre">Chambres </label>
                    <input type="number" min="0" class="form-control" formControlName="chambre" id="chambre">
                  </div>
                  <div class="col-md-3">
                    <label for="douche">Douches </label>
                    <input type="number" min="0" class="form-control" formControlName="douche" id="douche">
                  </div>
                  <div class="col-md-3">
                    <label for="salon">Salons </label>
                    <input type="number" min="0" class="form-control" formControlName="salon" id="salon">
                  </div>
                  <div class="col-md-3">
                    <label for="garage">Garages </label>
                    <input type="number" min="0" class="form-control" formControlName="garage" id="garage">
                  </div>
                  <div class="col-md-3">
                    <label for="cuisine">Cuisine </label>
                    <input type="number" min="0" class="form-control" formControlName="cuisine" id="cuisine">
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Les informations relatives aux équipements du bien</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="equipementForm">
                <div class="form-group">
                  <div class="row m-4">
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="wifi" type="checkbox" formControlName="wifi">
                        <label for="wifi">WiFi </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="piscine" type="checkbox" formControlName="piscine">
                        <label for="piscine">Piscine </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="securite" type="checkbox" formControlName="securite">
                        <label for="securite">Gardien de Sécurité</label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="clim" type="checkbox" formControlName="clim">
                        <label for="clim">Air Conditionné </label>
                      </p>
                      <p>
                        <input class="form-check-input" id="urgence" type="checkbox" formControlName="urgence">
                        <label for="urgence">Issue d'urgence</label>
                      </p>
                      <p>
                        <input class="form-check-input" id="incendie" type="checkbox" formControlName="incendie">
                        <label for="incendie">Borne d'incendie </label>
                      </p>
                    </div>
                    <div class="col-md-4">
                      <p>
                        <input class="form-check-input" id="parking" type="checkbox" formControlName="parking">
                        <label for="parking">Parking </label>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> La gallerie du bien</span>
            <div class="col-md-12">
              <app-folder-upload (filesUploaded)="uploadFile($event, 'GALLERY')" [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']" [etat]="'add'" [folder]="null">
              </app-folder-upload>
            </div>
          </div>
          <div class="row m-2 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Video de présentation</span>
            <div class="col-md-12">
              <form autocomplete="off" [formGroup]="videoForm">
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-12">
                      <label for="link">Lien de la vidéo <span class="asterix">*</span></label>
                      <input type="text" class="form-control" formControlName="link" id="link">
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row m-4 mb-2">
            <span class="badge badge-secondary my-2 f-14 width"> Plan</span>
            <div class="col-md-12">
              <app-folder-upload-2 (filesUploaded)="uploadFile($event, 'PLAN')" [maxSize]="3"
                [type]="['jpg', 'png', 'jpeg']" [etat]="'add'" [folder]="null">
              </app-folder-upload-2>
            </div>
          </div>
          <div class="col-sm-12 text-center mt-3">
            <div class="btn-group">
              <button type="button" awPreviousStep class="btn btn-warning">
                <i class="feather icon-arrow-left"></i> Précédent
              </button>
            </div>
          </div>
        </aw-wizard-step>
      </aw-wizard>
    </div>
  </div>
  <div class="modal-footer">
    <button (click)="modal.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
      Fermer <i class="feather icon-x-circle"></i>
    </button>
    <button (click)="form.reset()" type="button" class="btn btn-warning">
      Vider <i class="fas fa-broom"></i>
    </button>
    <button [disabled]="form.invalid" type="submit" class="btn btn-primary">
      Enregistrer <i class="feather icon-save"></i>
    </button>
  </div>
</form>